<template>
    <div class="mvt-rating">
        <mvtRadio v-model="_value" :data="data"/>
    </div>
</template>
<script src="./mvt-rating.js"></script>
<style lang="scss">
@use "./mvt-rating.scss" as *;
</style>